export default class HiddenNav {
	constructor( listContainer ) {
		/**
		 * Nodes
		 */
		this._list = listContainer;
		this._listItems = Array.from( this._list.children );
		
		this._hiddenListContainer = null;
		this._hiddenList = null;

		this._visibleListItems = [];
		this._hiddenListItems = [];
		/** */

		/**
		 * Classes
		 */
		this._hiddenListShowClass = 'show-hidden-navs';
		this._hiddenListContainerClass = 'hidden-navs';
		/** */

		/**
		 * Handlers
		 */
		this._hiddenListContainerClickHandler = null;
		this._documentClickHandler = null;
		this._windowResizeHandler = null;
		/** */

		/**
		 * Flags
		 */
		this._isHiding = null;
		/** */
	}

	/**
	 * Public
	 */
	init( isHiding = true )
	{
		this._isHiding = isHiding;
		
		if ( this._isHiding )
		{
			this.startHiding();
		}
		
		this._list.classList.add( 'loaded' );
	}
	
	isHiding()
	{
		return this._isHiding;
	}

	stopHiding()
	{
		this._isHiding = false;
		this._listItems.slice().reverse().forEach( ( item ) => this._list.insertAdjacentElement( 'afterbegin', item ) );
		this._removeHiddenListContainerClickHandler();
		this._removeWindowResizeHandler();
		this._removeHiddenListContainer();
	}

	startHiding()
	{
		this._isHiding = true;
		this._createHiddenListContainer();
		this._hideHiddenListContainer();
		this._updateList();
		this._setHiddenListContainerClickHandler();
		this._setWindowResizeHandler();
	}
	/** */
	
	/**
	 * Private
	 */
	_createHiddenListContainer()
	{
		if ( !this._hiddenListContainer )
		{
			this._hiddenListContainer = document.createElement( 'li' );
			this._hiddenList = document.createElement( 'ul' );
			this._hiddenListContainer.classList.add( this._hiddenListContainerClass );
			this._hiddenListContainer.appendChild( this._hiddenList );
			this._list.appendChild( this._hiddenListContainer );
		}
	}

	_removeHiddenListContainer()
	{
		if ( this._hiddenListContainer )
		{
			this._hiddenListContainer.remove();
			this._hiddenListContainer = null;
			this._hiddenList = null;
		}
	}

	_showHiddenListContainer()
	{
		this._hiddenListContainer.style.display = '';
		this._list.classList.remove( 'hide' );
	}

	_hideHiddenListContainer()
	{
		this._hiddenListContainer.style.display = 'none';
		this._list.classList.add( 'hide' );
	}
	
	_updateList()
	{
		if ( this._isHiding )
		{
			const itemTest = this._visibleListItems.length ? this._visibleListItems[0] : this._listItems[0];
			const listItemMargin = parseFloat( window.getComputedStyle( itemTest, null ).getPropertyValue( 'margin-right' ) );
			const hiddenListContainerWidth = parseFloat( window.getComputedStyle( this._hiddenListContainer, null ).getPropertyValue( 'width' ) );
			let visibleItemsWidth = 0;
			this._visibleListItems = [];
			this._hiddenListItems = [];
			
			this._listItems.forEach( ( item ) => {
				visibleItemsWidth += item.offsetWidth + listItemMargin;
				
				if ( visibleItemsWidth + hiddenListContainerWidth <= this._list.offsetWidth )
				{
					this._visibleListItems.push( item );
				}
				else
				{
					this._hiddenListItems.push( item );
				}
			} );

			if ( this._hiddenListItems.length )
			{
				this._showHiddenListContainer();
			}
			else
			{
				this._hideHiddenListContainer();
			}
			
			this._visibleListItems.reverse().forEach( ( item ) => this._list.insertAdjacentElement( 'afterbegin', item ) );
			this._hiddenListItems.forEach( ( item ) => this._hiddenList.appendChild( item ) );
		}
	}

	_setHiddenListContainerClickHandler()
	{
		document.removeEventListener( 'click', this._hiddenListContainerClickHandler );
		
		this._hiddenListContainerClickHandler = ( {target} ) => {
			const listItem = target.closest( `li.${this._hiddenListContainerClass}` );
			
			if ( listItem === this._hiddenListContainer )
			{
				this._hiddenListContainer.classList.toggle( this._hiddenListShowClass );
			}

			if ( listItem !== this._hiddenListContainer && this._hiddenListContainer.classList.contains( this._hiddenListShowClass ) )
			{
				this._hiddenListContainer.classList.remove( this._hiddenListShowClass );
			}
		};
		
		document.addEventListener( 'click', this._hiddenListContainerClickHandler );
	}

	_removeHiddenListContainerClickHandler()
	{
		document.removeEventListener( 'click', this._hiddenListContainerClickHandler );
		this._hiddenListContainerClickHandler = null;
	}

	_setWindowResizeHandler()
	{
		const onWindowResize = () => this._updateList();
		this._windowResizeHandler = onWindowResize;
		window.addEventListener( 'resize', onWindowResize );
	}

	_removeWindowResizeHandler()
	{
		window.removeEventListener( 'resize', this._windowResizeHandler );
		this._windowResizeHandler = null;
	}
}
